/* eslint-disable react/prop-types */
import React, { useReducer, createContext, useContext } from "react";
import QuizReducer from "src/reducers/QuizReducer";
const QuizContext = createContext();

// eslint-disable-next-line no-unused-vars
import QuestionsJSONProd from "src/data/questions-prod.json";
// eslint-disable-next-line no-unused-vars
import QuestionsJSONLocal from "src/data/questions-local.json";
// setup default
const defaultStatus = window?.config?.articles?.length
  ? "recommendations"
  : "start";

const initialState = {
  questions: QuestionsJSONProd,
  // questions: QuestionsJSONLocal,

  // 'loading', 'error', 'ready', 'active', 'finish'
  // Status doesn't do anything for testing purposes, to adjust in quiz.jsx
  status: "loading",
  questionNo: 1,
  questionSection: 1,
  questionSequence: 1,
  quizStatus: defaultStatus,
  prevQuizStatus: null,
  /*
   start = start screen, 
  progress = answering questions, 
  summary = summary (edit confirmations)
  edit = editing a single question
  finished = finish screen
  recommendations = recommendations component
  closed = splash component
  */
  questionEditStatus: {
    questionKey: null,
    value: null,
  },
  snapshot: {
    questionNo: null,
    questionSection: null,
  },
  articles: [],
  windowWidth: window.innerWidth,
  qContainerref: null, // ref to the _q-container div (used to scroll top on mobile)
  qHeaderResponsesRef: null, // ref to the q-responses div (used to scroll bottom mobile)
  quizAnswers: [],
};

function QuizProvider({ children }) {
  const [
    {
      questions,
      status,
      questionNo,
      questionSection,
      quizStatus,
      questionEditStatus,
      prevQuizStatus,
      articles,
      windowWidth,
      questionSequence,
      snapshot,
      quizAnswers,
    },
    dispatch,
  ] = useReducer(QuizReducer, initialState);

  return (
    <QuizContext.Provider
      value={{
        questions,
        status,
        questionNo,
        questionSection,
        quizStatus,
        questionEditStatus,
        prevQuizStatus,
        articles,
        windowWidth,
        questionSequence,
        snapshot,
        dispatch,
        quizAnswers,
      }}
    >
      {children}
    </QuizContext.Provider>
  );
}

function useQuiz() {
  const context = useContext(QuizContext);
  if (context === undefined)
    throw new Error("QuizContext was used outside of the QuizProvider");
  return context;
}

export { QuizProvider, useQuiz };
